class DirectoryError extends Error {
    constructor(response,message) {
      super(message); // (1)
      this.response = response;
    }
  }


  export default  DirectoryError;